import { db } from "../storage/storage";
import { IdeaflowUser } from "./useAuth";

// ts-prune-ignore-next
export type Auth = AuthLoggedIn | AuthLoggedOut;

// ts-prune-ignore-next
export type AuthLoggedIn = {
  type: "logged-in";
  accessToken: string;
  user: IdeaflowUser;
};

// ts-prune-ignore-next
export type AuthLoggedOut = {
  type: "logged-out";
};

const authKey = "auth-state";

export async function getAuth(): Promise<Auth | null> {
  const value = await db.kv.get(authKey);
  if (!value) {
    return null;
  }
  return JSON.parse(value as string) as Auth;
}

// ts-prune-ignore-next
export async function setAuth(auth: Auth) {
  await db.kv.set(authKey, JSON.stringify(auth));
}

// ts-prune-ignore-next
export async function clearAuth() {
  await db.kv.remove(authKey);
}
